import { Button } from '@altify/components';
import { useContent } from '@altify/utils';
import {
  useAddStockToLeadMutation,
  useGetStocksFromLeadQuery,
} from 'store/slices/leads-api';
import { exploreProductsContent } from '../explore.content';

export function GetNotifiedButton({ productCode, isMobile = false }: { productCode: string, isMobile?: boolean }) {
  const localizedContent = useContent(exploreProductsContent);

  const { data: stocksFromLead } = useGetStocksFromLeadQuery();
  const isInLead = stocksFromLead?.includes(productCode.toUpperCase());

  const [addStockToLead, { isLoading: isAddingStockToLead }] =
    useAddStockToLeadMutation();

  return (
    <Button
      size="medium"
      onPress={() => addStockToLead(productCode.toUpperCase())}
      fullWidth={false}
      disabled={isInLead}
      loading={isAddingStockToLead}
      text={
        isInLead
          ? localizedContent.launchNotificationSet
          : localizedContent.getNotified
      }
      className={`ml-auto ${isMobile ? 'mr-0' : 'mr-11'}`}
    />
  );
}
